import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import getQueryKeys from "common/datahooks/getQueryKeys";
import useCustomer from "common/datahooks/useCustomer";
import { get } from "common/helpers/HTTP";

import type { AgencySettings } from "../types";

async function getAgencySettingsRequest(
  whitelabelId: string,
): Promise<AgencySettings> {
  return (await get(`agency/customizations/${whitelabelId}`)).customization;
}

export default function useAgencySettings() {
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { agencySettingsKey } = getQueryKeys(workspaceId);
  const { customerInfo } = useCustomer();

  const { data: agencySettings, isLoading: isLoadingAgencySettings } = useQuery(
    {
      queryKey: agencySettingsKey,
      queryFn: () => getAgencySettingsRequest(customerInfo.chargebee_id),
    },
  );

  return {
    agencySettings,
    isLoadingAgencySettings,
  };
}
